import { customStorage } from './CommonService';
import { STO_ACCESS_TOKEN, STO_REFRESH_TOKEN } from '../constants/commonConstants';

// Access token lives in memory; the refresh token is persisted so a page
// reload can silently obtain a new access token.
let inMemoryAccessToken = null;

const getAccessToken = () => inMemoryAccessToken;

// Decode only as a renewal hint. The API remains the JWT authority.
const getAccessTokenExpiresIn = () => {
    try {
        const payload = inMemoryAccessToken?.split('.')[1];
        if (!payload) return null;
        const exp = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))).exp;
        return typeof exp === 'number' ? exp - Date.now() / 1000 : null;
    } catch (_) { return null; }
};

const setTokens = (accessToken, refreshToken) => {
    inMemoryAccessToken = accessToken || null;
    if (refreshToken) {
        customStorage.setItem(STO_REFRESH_TOKEN, refreshToken);
    }
};

const getRefreshToken = () => customStorage.getItem(STO_REFRESH_TOKEN);

const clearTokens = () => {
    inMemoryAccessToken = null;
    customStorage.removeItem(STO_REFRESH_TOKEN);
    customStorage.removeItem(STO_ACCESS_TOKEN);
    window.dispatchEvent(new CustomEvent('pwf-auth-session-ended'));
};

const isAuthenticated = () => !!inMemoryAccessToken || !!getRefreshToken();

export { getAccessToken, getAccessTokenExpiresIn, setTokens, getRefreshToken, clearTokens, isAuthenticated };
